module.exports = __webpack_public_path__ + "static/media/edit.bfc9715d.svg";